<template lang="html">

  <section class="ficha-proyecto">

    <project-togo v-if="$route.params.id == 'togo'"></project-togo>
    <project-view v-else></project-view>

  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'


  import projecttogo from '@/components/views/project-togo';

  import projectview from '@/components/views/project-view'


  export default {
    name: 'ficha-proyecto',
    components: {
      'project-togo' : projecttogo,
      'project-view' : projectview
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/views/ficha-project.vue